import { styled } from "@mui/system";
import { Box } from "@mui/material";

export const StyledContainer = styled(Box)(() => ({
  width: "100%",
  textAlign: "center",
  height: "23.5px",
}));
